import {
  questionSetSlugFromParamsProps,
  pubSlugFromParamsProps,
} from 'client/embed/shared/functions';
import {
  useCurrentRespondent,
  CurrentRespondent,
  CurrentUser,
} from 'client/respondent/hooks';
import { ClientUrlUtils } from 'client/shared/core/helpers';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { VotingPageInner } from '../../../respondent/voting/shared/pages/voting-wrapper/index';

export type Props = RouteComponentProps<{
  readonly setSlug: string;
  readonly pubSlug: string;
}>;

export const GenericContentPage: React.FC<Props> = (p: Props) => {
  const setSlug = questionSetSlugFromParamsProps(p);
  const pubSlug = pubSlugFromParamsProps(p);
  const currentUser = useCurrentRespondent();

  const respondentUser =
    CurrentRespondent.RESPONDENT.isA(currentUser) ||
    CurrentRespondent.GUEST_RESPONDENT.isA(currentUser)
      ? currentUser
      : null;

  return (
    <GenericContentPageInner
      pubSlug={pubSlug}
      respondentUser={respondentUser}
      setSlug={setSlug}
    />
  );
};
GenericContentPage.displayName = 'GenericContentPage';

interface InnerProps {
  readonly setSlug: string;
  readonly pubSlug: string;
  readonly respondentUser: CurrentUser | null;
}

export const GenericContentPageInner: React.FC<InnerProps> = (props) => {
  return (
    <VotingPageInner
      animateDirection={'slideInRight'}
      curUser={props.respondentUser}
      goBack={function (): void {
        window.open(ClientUrlUtils.respondent.feed.url(), '_blank');
      }}
      goToFeed={function (): void {
        window.open(ClientUrlUtils.respondent.feed.url(), '_blank');
      }}
      setHideRightSidebar={function (): void {
        return;
      }}
      setShowTermsAndPrivacyMobile={function (): void {
        return;
      }}
      showingSidebars={false}
      slugs={{ setSlug: props.setSlug, pubSlug: props.pubSlug }}
    />
  );
};
